import Datatable from './Datatable';

export { Datatable };
